import { useState } from "react";
import { ACE_BLOCK_MESSAGES } from "../../utils/constants";
import SidebarSenasaElectronic from "../Sidebar/SidebarSenasaElectronic";
import StandaloneMessage from "../StandaloneMessage/StandaloneMessage";
import {
  Container,
  DamInfo,
  StatusCard,
  StatusDiv,
  StatusInfo,
} from "./DamStatusSidebarAdminStyles";
import SenasaRestrictedCodes from "../SenasaRestrictedCodes";

const dictionary = {
  electronic_mandate_status: "MANDATO ELECTRÓNICO",
  senasa_status: "RESTRICCIÓN SENASA",
  ace_block_status: "BLOQUEO ACE",
  levante_status: "RESTRICCIÓN DE LEVANTE",
  endorsement_status: "endorsement_status",
  handling_payment_status: "handling_payment_status",
};

export const DamStatusSidebarAdmin = (props) => {
  const { dam, status } = props;
  const { problems } = status;

  const restrictedCodes: string[] = (dam.senasa_restricted_tariff ?? "")
    .trim()
    .split(",")
    .filter(Boolean);

  const numberProblems = problems.length;

  const [showSidebar, updateShowSidebar] = useState(false);

  const toggleStatusSidebar = () => {
    updateShowSidebar(!showSidebar);
  };
  return (
    <StatusDiv
      status={numberProblems === 0 ? "ok" : "problem"}
      onClick={toggleStatusSidebar}
      clickable={true}
      style={{ cursor: "pointer" }}
    >
      <span>{`${numberProblems === 0 ? "SIN" : numberProblems} RESTRICCI${
        numberProblems === 1 ? "ÓN" : "ONES"
      }`}</span>
      {showSidebar && (
        <SidebarSenasaElectronic onOutsideClick={toggleStatusSidebar}>
          <Container>
            <DamInfo className="header">
              <p className="dam-id">{`${dam.id}`}</p>
              <p className="consignee-name">{dam.consigneeName}</p>
              <StatusDiv status={numberProblems > 0 ? "problem" : "ok"}>
                <span>{`${
                  numberProblems === 0 ? "SIN" : numberProblems
                } RESTRICCI${numberProblems === 1 ? "ÓN" : "ONES"}`}</span>
              </StatusDiv>
            </DamInfo>
            <StatusInfo className="content">
              {numberProblems === 0 && (
                <StandaloneMessage>
                  Esta DAM no tiene ninguna restricción.
                </StandaloneMessage>
              )}
              {numberProblems > 0 &&
                problems.map((problem, index) => {
                  return (
                    <StatusCard key={index}>
                      <div className="status-section">
                        <StatusDiv status={problem.category}>
                          <span>{dictionary[problem.key].toUpperCase()}</span>
                        </StatusDiv>
                        <StatusDiv status={problem.category}>
                          <span>{problem.label.toUpperCase()}</span>
                        </StatusDiv>
                      </div>
                      {problem.key === "ace_block_status" ? (
                        ACE_BLOCK_MESSAGES[problem.code].map(
                          (message, index) => {
                            return <p key={index}>{message}</p>;
                          }
                        )
                      ) : (
                        <p>{problem.message}</p>
                      )}
                    </StatusCard>
                  );
                })}
            </StatusInfo>
            <SenasaRestrictedCodes
              restrictedCodes={restrictedCodes}
              margins={[10, 0, 0, 15]}
              className="content"
            />
          </Container>
        </SidebarSenasaElectronic>
      )}
    </StatusDiv>
  );
};
